var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[(_vm.loading)?_c('div',{staticClass:"absolute inset-0 bg-black bg-opacity-10 z-40"},[_c('loader',{staticClass:"absolute center-h-v"})],1):_vm._e(),_c('ve-table',{staticClass:"p-3",attrs:{"columns":_vm.columns,"table-data":_vm.tableData,"row-style-option":_vm.rowStyleOption,"border-x":true,"border-y":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }